import { ButtonProps } from 'lib/components/Button/Button'
import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

import { IconListItem } from '@/components/IconList'

export interface AffiliatePageContent {
  hero: NarrativeHeroProps
  fifties: FiftyFiftyProps[]
  iconListHeader: string
  iconList: IconListItem[]
  leadFormProps: {
    header: string
    subHead: React.ReactNode
  }
  ctaHeader: string
  ctaBody: string
  ctaButtonLink: ButtonProps
  ctaButtonText: string
}

const BACKGROUND_IMAGE = '/images/shipplay/hero/partner-2.webp'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'Join our affiliate program.',
  subHeader: `
    Earn money and make travel easier for your
    audience with the trusted name in door-to-door luggage and gear shipping.
  `,
  button: {
    children: 'Become an affiliate',
    link: {
      href: '#lead-form',
    },
    variant: 'secondary',
  },
}

const fifties: FiftyFiftyProps[] = [
  {
    image: {
      src: '/images/shipplay/partner-1.webp',
    },
    backgroundColor: 'white',
    header: 'Why us?',
    layout: 'image-right',
    button: {
      text: 'Become an Affiliate',
      link: {
        href: '#lead-form',
      },
    },
    body: (
      <>
        Ship&Play makes travel a breeze by shipping luggage, gear, and the bulky stuff right to the
        hotel, resort, or destination and back again. Trusted by travelers with more than 38,000
        5-star reviews, Ship&Play is a service you can recommend with confidence.
      </>
    ),
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipplay/partner-1.webp',
    },
    backgroundColor: 'white',
    header: 'What\u2019s in it for you?',
    layout: 'image-left',
    body: (
      <>
        In exchange for sharing the benefits of using Ship&Play, you&apos;ll receive financial
        rewards as well as genuine appreciation from followers who use the service.
      </>
    ),
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipplay/partner-1.webp',
    },
    backgroundColor: 'white',
    header: 'How to join.',
    layout: 'image-right',
    button: {
      text: 'Become an Affiliate',
      link: {
        href: '#lead-form',
      },
    },
    body: (
      <>
        Joining is FREE. Just fill out the form linked below, and we&apos;ll help you find the
        partnership that makes the most sense (and money) for you.
      </>
    ),
    showEyebrow: false,
  },
]

const iconListHeader: string = 'Things to brag about'

const iconList: IconListItem[] = [
  {
    icon: 'check-circle-filled',
    header: 'Trusted by travelers',
    body: (
      <>
        With more than 500,000 bags shipped annually, Ship&Play is the trusted name in hands-free
        travel.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Premium experience',
    body: (
      <>
        Real-time tracking, free insurance, and customer support 7 days a week makes for a much
        better experience than wrestling bags through the airport.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'In good company',
    body: (
      <>
        We deliver to thousands of hotels, resorts, and destinations around the world. They trust us
        to deliver exceptional service and so can your audience.
      </>
    ),
  },
]

const leadFormProps = {
  header: 'Let\u2019s talk.',
  subHead: (
    <>
      Becoming a Ship&Play affiliate is simple, fast, and free. Want in? Fill out the form to get
      started - we&apos;ll be in touch with next steps.
    </>
  ),
}

const ctaHeader: string = 'Are you representing a hotel, resort or travel service?'
const ctaBody: string = 'If so, check out our partner page.'
const ctaButtonLink: ButtonProps = {
  link: {
    href: '/partnership-benefits',
    target: '_self',
  },
  variant: 'secondary',
}
const ctaButtonText: string = 'Learn More'

const content: AffiliatePageContent = {
  hero,
  fifties,
  iconListHeader,
  iconList,
  leadFormProps,
  ctaHeader,
  ctaBody,
  ctaButtonLink,
  ctaButtonText,
}

export default content
